import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import {
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
} from 'firebase/auth';
import { auth } from '../../../config/config-firebase';
import { useAppSelector } from '../../../reduxStore/utils/reduxHooks';

interface Props {
  compact?: boolean;
}

const AuthControls: React.FC<Props> = ({ compact }) => {
  const { user, role } = useAppSelector((state) => state.auth);

  const handleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
    } catch (e) {
      console.log('[AuthControls] signIn error', e);
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (e) {
      console.log('[AuthControls] signOut error', e);
    }
  };

  if (compact) {
    return (
      <Box sx={{
        px: 1, py: 1, display: 'flex', justifyContent: 'center',
      }}
      >
        {user ? (
          <Tooltip title="Sign out">
            <IconButton onClick={handleSignOut} size="small" sx={{ color: '#F8FAFC' }}>
              <LogoutIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Sign in with Google">
            <IconButton onClick={handleSignIn} size="small" sx={{ color: '#F8FAFC' }}>
              <LoginIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ px: 2, py: 2 }}>
      <Box sx={{
        display: 'flex', alignItems: 'center', gap: 1, mb: 1,
      }}
      >
        <Avatar src={user?.photoURL || undefined} sx={{ width: 28, height: 28 }} />
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="body2" noWrap sx={{ color: '#F8FAFC' }}>
            {user?.displayName || user?.email || 'Guest'}
          </Typography>
          <Typography variant="caption" noWrap sx={{ color: 'rgba(248, 250, 252, 0.8)' }}>
            Role:
            {' '}
            {role}
          </Typography>
        </Box>
      </Box>
      {user ? (
        <Button variant="outlined" size="small" onClick={handleSignOut} fullWidth>
          Sign out
        </Button>
      ) : (
        <Button variant="contained" size="small" onClick={handleSignIn} fullWidth>
          Sign in with Google
        </Button>
      )}
    </Box>
  );
};

export default AuthControls;
